import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { htmlToText } from "../../../utils/toDisplayString";

// Single-line system-alert notification. Renders nothing when there are no
// alerts. Used at the very top of the Exam Purchases page.
const ExamSystemAlerts = ({ alerts }) => {
  const list = Array.isArray(alerts) ? alerts : [];
  if (list.length === 0) return null;

  const alertText = (a) => `${a.area ? `${htmlToText(a.area)}: ` : ""}${htmlToText(a.message)}`;

  return (
    <div
      className="flex items-center gap-2 overflow-hidden rounded-lg border border-amber-200 bg-amber-50 px-3 py-1.5"
      title={list.map(alertText).join("\n")}
    >
      <FontAwesomeIcon icon={faTriangleExclamation} className="shrink-0 text-amber-600" />
      <span className="shrink-0 text-[11px] font-bold uppercase tracking-wide text-amber-800">
        System Alerts
      </span>
      <span className="truncate text-xs text-slate-700">
        {list.map(alertText).join("  •  ")}
      </span>
    </div>
  );
};

export default ExamSystemAlerts;
